import {createAction} from "redux-act";
import {IGameBar, IGetGameBarRequest} from "apps/FIVES/modules/types";

export const fetchGameBar = createAction<IGetGameBarRequest>();
export const fetchGameBarSuccess = createAction<IGameBar>();
export const fetchGameBarFailed = createAction<Error["message"]>();
